import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    showAllBtn: true // 是否显示所有长按按钮
  },
  mutations: {
    // 是否隐藏所有附件下载按钮
    setShowAllBtn (state, msg) {
      state.showAllBtn = msg
    }
  }

})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js